<script setup>
// Constants declarations
const attrs = useAttrs()

// Component props
const props = defineProps({
  icon: {
    type: String,
    required: false,
    default: null,
  },
  tooltip: {
    type: undefined,
    required: true,
  },
  disable: {
    type: Boolean,
    required: false,
    default: false,
  },
  size: {
    type: String,
    required: false,
    default: 'md',
  },
  customTooltip: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>

<template>
  <q-btn
    class="btn--no-hover q-pa-none action-buttons"
    flat
    :icon="icon"
    :size="size"
    :disable="disable"
    :class="{ 'text-negative': icon === 'sym_o_delete' }"
    v-bind="$attrs"
  >
    <q-tooltip v-if="!customTooltip" :delay="500" anchor="center left" self="center end">
      {{ tooltip }}
    </q-tooltip>
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}"></slot>
    </template>
  </q-btn>
</template>

<style scoped></style>
